<template>
  <!--
    作者：kmdshop
    时间：2020-06-04
    描述：插件中心-积分商城-商品列表
  -->
  <div class="user" v-loading="loading">
    <el-form size="small" :inline="true" class="demo-form-inline">

      <el-form-item label="用户昵称/手机号"><el-input size="small"  placeholder="请输入用户昵称/手机号" v-model="form_inline.name"></el-input></el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
   
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" v-auth="'/plus/shareholder/index/add'">添加</el-button>
    </div>
    <div class="product-content point-list">
      <div class="table-wrap">
        <el-table size="small" :data="tableData"  border style="width: 100%">
          <el-table-column prop="user.nickName" label="关联会员">
            <template slot-scope="scope">
             <div >
              {{ scope.row.user.mobile }}({{ scope.row.user.nickName  }})
             </div>
            </template>
          </el-table-column>

          <!-- <el-table-column label="优惠类型">
            <template slot-scope="scope">
             <div >
              {{ scope.row.dis_status==1?"固定":"比例" }}
             </div>
            </template>
          </el-table-column> -->
<!-- 
          <el-table-column  prop="discounts" label="优惠比例">
            <template slot-scope="scope">
             <div >
              <span v-if=" scope.row.dis_status == 1">{{ scope.row.discounts  }}元</span>
              <span v-if=" scope.row.dis_status == 2">{{ scope.row.discounts  }}%</span>
             </div>
          
            </template>  
          </el-table-column>
          <el-table-column prop="user.nickName" label="优惠金额">
            <template slot-scope="scope">
              <span v-if="scope.row.dis_status == 1">举例：商品100元，抵扣{{ scope.row.discounts }}元</span>
            <span v-if="scope.row.dis_status == 2">举例：商品100元，抵扣{{ getPrice(100*(1-scope.row.discounts/100)) }}元</span>
            </template>
          </el-table-column> -->


        
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0" >关闭</span>
              <span v-if="scope.row.status == 1" >开启</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button v-auth="'/plus/shareholder/index/edit'" @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
              <el-button v-auth="'/plus/shareholder/index/delete'" @click="deleteClick(scope.row.shareholder_id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"  @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>

     <!--编辑-->
     <Edit v-if="open_edit" :open_edit="open_edit"   :form="userModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
   <!--添加-->
   <Add v-if="open_add" :open_add="open_add"  @closeDialog="closeDialogFunc($event, 'add')"></Add>

<!--编辑-->

  
  </div>
</template>
<script>
import ShareholderApi from '@/api/shareholder.js';
import Edit from './edit.vue';
  import Add from './add.vue';
export default {
  components: {
      /*编辑组件*/
      Edit,
      Add
    },
  data() {
    return {
      /*表格数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*是否加载完成*/
      loading: true,
      /*当前编辑的对象*/
      userModel: {},
      /*是否打开选择商品*/
      isproduct: false,
      /*已有的id*/
      exclude_ids: [],
       /*是否打开添加弹窗*/
       open_add: false,
        /*是否打开编辑弹窗*/
        open_edit: false,
        form_inline:{
          name:""
        }

    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
        /*搜索查询*/
        onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },
    roundToDecimalPlace(number, decimalPlaces) {
        const factor = Math.pow(10, decimalPlaces);
        return Math.round(number * factor) / factor;
      },
      getPrice(price){
        console.log("price",this.roundToDecimalPlace(price,2))
        return this.roundToDecimalPlace(price,2)
      },
      /*打开添加*/
      addClick() {
        this.open_add = true
      },

      /*打开编辑*/
      editClick(item) {
        this.userModel = (item)
        console.log(" this.userModel", this.userModel)
        this.open_edit = true
      },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },
 /*关闭弹窗*/
 closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog
          if (e.type == 'success') {
            this.getTableList()
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.form_inline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      ShareholderApi.index(Params, true)
        .then(res => {
          self.exclude_ids = res.data.exclude_ids;
          self.tableData = res.data.list.data;
          self.totalDataNumber = res.data.list.total;
          self.loading = false;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*打开添加*/
    changeProduct(list) {
      this.isproduct = true;
    },

    /*关闭商品选择*/
    closeProductFunc(e) {
      this.isproduct = false;
      if (e.type == 'success') {
        this.addClick(e.params.product_id);
      }
    },

    ///*添加商品*/
    // addClick(product_id) {
    //   this.$router.push('/plus/shareholder/index/add?product_id=' + product_id);
    // },

    // /*编辑商品*/
    // editClick(e) {
    //   let self = this;
    //   this.$router.push({
    //     path: '/plus/shareholder/index/edit',
    //     query: {
    //       shareholder_id: e
    //     }
    //   });
    // },

    /* 查询*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      self.getTableList();
    },

    /*删除用户*/
    deleteClick(e) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          ShareholderApi.deleteShareholder(
            {
              shareholder_id: e
            },
            true
          )
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getTableList();
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    }

  }
};
</script>

<style>
.point-list .el-input-number--mini {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/shareholder/index/index.vue